<template lang="pug">
nav.navbar.main-navigation(
    v-show="show"
    v-bind:class="className"
    role="navigation"
    v-bind:aria-label="$t('navigation.main')")

    div.navbar-brand
        router-link(
            to="/"
            v-bind:aria-label="$t('navigation.home')")
            img.logo(
                aria-hidden="true"
                v-bind:src="logoSrc"
                v-bind:alt="$site"
                width="137"
                height="70")


        //- login and register buttons outside the burger menu with @media max-width 1023px
        register-button.navbar-item.register.anon(
            v-if="!isAuthenticated"
            v-bind:is-authenticated="isAuthenticated"
            ref="regsr1")
        login-button.navbar-item.login.anon(
            v-if="!isAuthenticated"
            v-bind:is-authenticated="isAuthenticated"
            ref="login1")

        div.navbar-burger.burger(
            aria-hidden="true"
            v-bind:class="menuExpanded ? 'is-active' : ''"
            v-on:click="toggleMenuExpansion")
            span
            span
            span


    div.navbar-menu(
        role="menubar"
        v-bind:style="getMenuStyle()"
        v-bind:class="getMenuClassName()")

        div.navbar-start

            //- index search
            icon-magnify.navbar-item.index-search(
                role="button"
                aria-pressed="false"
                v-bind:aria-label="$t('navigation.searchIndex')"
                v-bind:title="$t('navigation.searchIndex')"
                v-on:click="$eventBus.$emit('show-search-overlay')")

            //- Artworks & Collections
            div.navbar-item.has-dropdown.is-hoverable.collections(
                role="none")
                router-link.navbar-link.is-hidden-touch(
                    tabindex="0"
                    v-bind:to="{ name: `${$i18n.locale}.Artworks` }") {{ $t('navigation.artworksAndCollections') }}

                div.navbar-dropdown.is-boxed
                    router-link.navbar-item(
                        tabindex="0"
                        v-bind:to="{ name: `${$i18n.locale}.Artworks` }") {{ $t('navigation.searchArtworks') }}

                    router-link.navbar-item(
                        tabindex="0"
                        v-bind:to="{ name: `${$i18n.locale}.Collections` }") {{ $t('navigation.searchCollections') }}

                    router-link.navbar-item(
                        tabindex="0"
                        v-bind:to="{ name: `${$i18n.locale}.Organizations` }")  {{ $t('navigation.searchOrganizations') }}

            //- Artists
            router-link.navbar-item(
                tabindex="0"
                v-bind:to="{ name: `${$i18n.locale}.Actors` }")
                span {{ $t('navigation.actors') }}

            //- Galleries
            router-link.navbar-item.disabled(
                tabindex="-1"
                aria-hidden="true"
                to="#")
                span {{ $t('navigation.galleries') }}

            //- Events
            router-link.navbar-item(
                tabindex="0"
                v-bind:to="{ name: `${$i18n.locale}.Events` }")
                span {{ $t('navigation.events') }}

            //- Articles
            router-link.navbar-item(
                tabindex="0"
                v-bind:to="{ name: `${$i18n.locale}.Articles` }")
                span {{ $t('navigation.articles') }}

            //- more...
            div.navbar-item.has-dropdown.is-hoverable.more(
                role="none")
                div.navbar-link.is-hidden-touch(
                    aria-hidden="true") {{ $t('navigation.more') }}
                div.navbar-dropdown.is-boxed
                    router-link.navbar-item(
                        tabindex="0"
                        v-bind:to="{ name: `${$i18n.locale}.Videos` }") {{ $t('navigation.videos') }}
                    router-link.navbar-item(
                        tabindex="0"
                        v-bind:to="{ name: `${$i18n.locale}.Audios` }") {{ $t('navigation.podcasts') }}

            router-link.navbar-item(
                v-if="communityShowNavigation"
                tabindex="0"
                v-bind:to="{ name: `${$i18n.locale}.Community` }")
                span {{ $t('navigation.community') }}


            div.navbar-end
                //- actions for authenticated users
                div.navbar-item.navbar-actions(
                    v-if="isAuthenticated"
                    role="group")
                    div.field.is-grouped(role="none")
                        //- edit mode toggle
                        div.control.navbar-icon(
                            role="presentation")
                            div.is-hidden-desktop(aria-hidden="true") {{ $t('navigation.editMode') }}
                            toggle-mode-edit(
                                role="button"
                                aria-pressed="false"
                                v-bind:aria-label="$t('navigation.editMode')")

                        //- public/private mode toggle
                        div.control.navbar-icon(
                            role="presentation")
                            div.is-hidden-desktop(aria-hidden="true") {{ $t('navigation.selectUseProfile') }}
                            select-use-profile(
                                role="button"
                                aria-pressed="false"
                                v-bind:aria-label="$t('navigation.selectUseProfile')")

                div.field.is-grouped(
                    role="none")

                    //- login and register buttons inside the burger menu with @media min-width 1024px
                    register-button.navbar-item.register(
                        v-if="!isAuthenticated"
                        v-bind:is-authenticated="isAuthenticated"
                        ref="regsr2")

                    login-button.navbar-item.login(
                        v-if="!isAuthenticated"
                        v-bind:is-authenticated="isAuthenticated"
                        ref="login2")

                    //- user profile (logged in)
                    div.navbar-item.has-dropdown.is-hoverable.login.logged-in(
                        v-else
                        role="none")
                        //- profile icon
                        router-link.navbar-link(
                            v-bind:to="{ name: 'UserProfile' }"
                            v-bind:aria-label="$t('user.myProfile')")
                            icon-account(title="" v-if="!avatar")
                            img.avatar(v-bind:src="avatar" alt="" v-else aria-hidden="true")
                            span.is-hidden-desktop(aria-hidden="true") {{ $t('navigation.user') }}

                        //- dropdown menu
                        div.navbar-dropdown.is-boxed.is-right(
                            role="none"
                            tabindex="-1"
                            aria-expanded="true"
                            aria-label="")
                            //- user profile
                            router-link.navbar-item(
                                tabindex="-1"
                                v-bind:to="{ name: 'UserProfile' }"
                                aria-hidden="true") {{ $t('user.myProfile') }}
                            //- Muusa tools
                            user-tool.navbar-item(
                                v-for="(tool, index) in userTools" v-bind:key="'tool' + index"
                                v-bind:tool="tool"
                                aria-hidden="true"
                                tabindex="-1"
                                theme="dark")
                            //- invite
                            //- router-link.navbar-item.develop-feature(
                            //-     v-bind:to="{name: 'UserProfile', params: {section: 'invitations'}}"
                            //-     ) {{ $t('user.sendInvitation') }}
                            //- logout
                            button.navbar-item.logout(
                                role="button"
                                aria-pressed="false"
                                tabindex="0"
                                v-on:click="$eventBus.$emit('user-logout')") {{ $t('user.logout') }}


                    //- language select
                    div.navbar-item.has-dropdown.is-hoverable.language-select(
                        role="menu"
                        aria-expanded="true"
                        v-bind:aria-label="$t('common.language') + ' ' + $i18n.locale")

                        div.navbar-item.is-hidden-desktop(aria-hidden="true") {{ $t('common.language') }}
                        div.navbar-link(aria-hidden="true") {{ $i18n.locale }}
                        div.navbar-dropdown.is-boxed(
                            role="none")
                            button.navbar-item(
                                v-for="(lang, index) in languages" v-bind:key="'lang' + index"
                                role="button"
                                tabindex="0"
                                v-bind:aria-label="lang.name"
                                v-bind:index="'lang' + index"
                                v-on:click="onChangeLanguage($event, lang)") {{ lang.name }}

                            toggle-dark-theme.navbar-item


</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import ThemeMixin from '@/components/Base/ThemeMixin.js';

const mapStateUser = createNamespacedHelpers('user').mapState;
const mapStateUx = createNamespacedHelpers('ux').mapState;

export default {
    name: 'navigation',

    props: {
        isAuthenticated: {  type: Boolean, required: true }
    },

    mixins: [ ThemeMixin ],

    components: {
        ToggleModeEdit: () => import('@/components/ToggleModeEdit.vue'),
        ToggleDarkTheme: () => import('@/components/ToggleDarkTheme.vue'),
        SelectUseProfile: () => import('@/components/SelectUseProfile.vue'),
        LoginButton: () => import('@/components/LoginButton.vue'),
        RegisterButton: () => import('@/components/RegisterButton.vue'),
        UserTool: () => import('@/components/User/Tool.vue')
    },

    computed: {
        ...mapStateUser({
            userProfile: state => state.profile
        }),

        ...mapStateUx({
            communityShowNavigation: state => state.communityShowNavigation
        }),

        languages: function () {
            return [{
                locale: "en",
                name: "In English"
            }, {
                locale: "fi",
                name: "Suomeksi"
            }, {
                locale: "sv",
                name: "På Svenska"
            }];
        }
    },

    data: function () {
        return {
            show: true,
            menuExpanded: false, // narrow display, hamburger expanded
            menuShouldAnimate: false, // animate only from the burger menu
            // debouncedScroll: _.debounce(this.onScroll, 200),
            className: '',
            logoHeight: null,
            logoSrc: require('assets/images/taide-art-white.svg'),
            userTools: [],
            avatar: null
        };
    },

    beforeMount: function () {
        this.update();

        // subscribe to navstyle events on global bus
        this.$eventBus.$on('style-change', this.onBusStyleChange);

        // listen for scroll event to resize the logo
        // window.addEventListener('scroll', this.debouncedScroll);
    },

    beforeDestroy: function () {
        this.$eventBus.$off('style-change', this.onBusStyleChange);

        // window.removeEventListener('scroll', this.debouncedScroll);
    },

    watch: {
        $route: function () {
            this.menuExpanded = false;
            this.className = this.getClassName();

            // navbar visibility is based on route
            this.show = !this.$route?.query?.hidenavigation;

            // close the search overlay
            this.$eventBus.$emit('show-search-overlay', true);
        },

        userProfile: function () {
            this.update();
        },

        isAuthenticated: function () {
            this.update();
        }
    },

    methods: {
        /**
         * Get css className from route meta `navbarClassName`.
         * Event bus style signal overrides this.
         */
        getClassName: function () {
            if (this.$route && this.$route.meta && this.$route.meta.navbarClassName) {
                return this.$route.meta.navbarClassName;
            }
            else {
                return '';
            }
        },

        /**
         * Navbar logo takes theme (= 'dark') value from the actual classnames list,
         * not the store. Route metas can override navbar style.
         */
        getLogoSrc: function () {
            let isDark = this.className.match('dark') || false;
            if (this.className.match('transparent')) {
                isDark = !isDark;
            }
            return this.getSiteLogoSrc(isDark);
        },

        onChangeLanguage: function (event, lang) {
            if (lang && lang.locale) {
                this.$eventBus.$emit('locale-change', lang.locale);
            }
            event.preventDefault();
            return false;
        },

        /**
         * Set `className` from bus value. Overrides getClassName.
         * Expects eg. {navigation: 'light'}
         */
        onBusStyleChange: function (styles) {
            if (styles && typeof styles.navigation !== 'undefined') {
                this.className = styles.navigation;
                this.logoSrc = this.getLogoSrc();
            }
        },

        /**
         * Resize the logo on scroll event
         */
        // onScroll: function () {
        //     const pageY = window.pageYOffset || document.documentElement.scrollTop;
        //     const el = document.querySelector('img.logo');
        //     let height = this.logoHeight || 56; // restore logo height set in css
        //     if (pageY > 0) {
        //         height = 56;
        //     }
        //     el && el.setAttribute('style', `height: ${height}px`);
        // },

        update: async function () {
            this.className = this.getClassName();
            this.logoSrc = this.getLogoSrc();

            if (this.isAuthenticated && this.userProfile) {
                // user profile image
                this.avatar = this.$helpers.getUserProfileImageSrc(this.userProfile, {resolution: {x: 120, y: 120, fixed: true}});

                // Muusa tools
                const userTools = this.userProfile.UserTools;
                if (userTools && userTools.length < 4) {
                    this.userTools = userTools;
                }
                else if (userTools) {
                    // select a subset of tools if there too many to list,
                    // and always include the last element
                    const tools = _.sortBy(_.take(_.shuffle(userTools), 2), 'ToolScopeName');
                    tools.push(_.last(userTools));
                    this.userTools = _.uniq(tools);
                }
            }
            else {
                this.avatar = null;
                this.userTools = [];
            }
        },

        toggleMenuExpansion: function () {
            this.menuExpanded = !this.menuExpanded;
            // toggle menu transition animation on/off
            this.menuShouldAnimate = true;
            if (!this.menuExpanded) {
                setTimeout(() => {
                    this.menuShouldAnimate = false;
                }, 2000);
            }
            // close the search overlay
            this.$eventBus.$emit('show-search-overlay', true);
        },

        /**
         * Menu CSS transition hacks
         */
        getMenuStyle: function () {
            if (this.menuExpanded) {
                // height transition effect does not work with 'auto',
                // thus the magic number that should be enough to leave space
                // for all of the items
                const height = this.isAuthenticated ? 770 : 550;
                return `height: ${height}px;`;
            }
            else {
                // this needs some height for the transition effect,
                // a slight delay for the other items to clear out
                // and transparent background so the 1px tall line is hidden
                return 'height: 1px;' +
                    'transition-delay: 0.6s;' +
                    'background-color: transparent;';
            }
        },

        /**
         * Get menu css class names.
         * When the window is resized, the transition should not take effect but be instant.
         * The animation should be seen only when clicking on the burger menu button.
         */
        getMenuClassName: function () {
            let klasses = this.menuExpanded ? 'is-active' : '';
            if (!this.menuShouldAnimate) {
                klasses += ' no-transition';
            }
            return klasses;
        }
    }
};
</script>

<style lang="scss">
// @import '~assets/styles/mixins';

$logo-height: 70px;

.navbar {
    display: flex;
    flex-wrap: nowrap;
    width: 100vw;
    height: auto;
    min-width: 100vw;
    max-width: 100vw;
    padding: 10px $main-content-margin;
    font-family: $helvetica-medium;
    font-size: 1.15rem;
    user-select: none;
    .navbar-brand {
        z-index: 8001;
        min-height: unset;
        margin: 10px 1rem 0 0;
        padding: 0;
        a {
            margin-right: 10px;
        }
        .logo {
            width: auto;
            height: $logo-height;
            margin: 0;
            @include transition-bezier(height);
        }
        // development tag just next to the logo
        .dev-tag {
            position: absolute;
            margin: ($logo-height - 10) auto auto 0;
            font-family: $helvetica-bold;
            font-size: 9px;
            color: $dark-gray-4;
        }
        // secondary login for narrow displays
        .login, .register {
            display: none;
            button {
                margin-left: auto;
            }
            @media screen and (max-width: $breakpoint-desktop - 1) { // bulma breakpoint!
                display: inline-flex;
                flex-grow: 1;
                justify-content: flex-end;
                &.login {
                    margin-right: 45px !important;
                }
            }
            @media screen and (max-width: $breakpoint-mobile - 1) {
                // drop register on mobile --
                // NOTE: in the script, login button shows the reg.info tooltip because of this!
                // TODO: place the logic somewhere
                &.register {
                    display: none;
                }
            }
        }
    }

    .navbar-burger {
        width: $main-content-margin - 7;
        height: 3em;
        color: $light-gray-2;
        transform: scale(2.25);
        @include transition-bezier(color);
        span {
            height: 1px; // burger line thickness
        }
        &:hover {
            background-color: transparent;
        }
    }

    .navbar-menu {
        display: flex !important;
        flex-grow: 1;
        flex-shrink: 1;
        flex-wrap: wrap;
        background-color: inherit;
        transform-origin: top;
        @include transition-bezier(all);
    }

    .navbar-start {
        z-index: inherit;
        flex-grow: 1;
        flex-shrink: 1;
        flex-wrap: wrap;
        align-content: center;
        justify-content: flex-start;
        margin: 0 0 0 auto;
        vertical-align: middle;
    }

    .navbar-item {
        display: inline-flex;
        margin: auto 0;
        font-family: $helvetica-medium;
        font-weight: normal;
        color: inherit;
        text-decoration: none;
        text-transform: uppercase;
        background-color: transparent;
        border-bottom: 1px solid transparent;
        outline: none !important;
        &:focus, &:not(:focus) {
            color: inherit !important;
            background-color: transparent !important;
        }
        &.navbar-icon {
            border-bottom: 0;
        }
        &.router-link-active {
            border-bottom: 1px solid white;
        }
        // the dropdown should overlay other menu elements
        &.has-dropdown {
            z-index: 5000;
        }
        &.collections {
            z-index: 5010;
        }
        &.index-search {
            width: 2rem;
            height: 2rem;
            margin-right: 1.5rem;
            cursor: pointer;
        }
        &.more {
            z-index: 5005;
        }
        .control.navbar-icon {
            margin: auto 0.75rem;
            font-size: inherit;
            &:not(:last-child) {
                margin-right: 1.25rem;
            }
        }
        .toggle-mode-edit,
        .select-use-profile {
            margin: 0.25rem auto;
            text-align: center;
        }
        .material-design-icon {
            width: 2rem;
            height: 2rem;
            margin: 0;
            margin-right: 0.5rem;
            color: inherit;
            vertical-align: middle;
            // transform: translateY(0px);
        }
    }

    .navbar-link {
        display: inline-flex;
        align-items: center;
        color: inherit;
        &:hover, &:focus, &:not(:focus) {
            color: inherit !important;
            background-color: transparent !important;
        }
        &::after {
            // bulma chevron
            border-color: white !important;
        }
    }

    // main navbar item font and transform
    .navbar-start > .navbar-item {
        text-shadow: 1px 1px 1px $dark-gray-3;
        &.navbar-item > span,
        .navbar-link {
            font-family: $helvetica-medium;
            font-weight: normal;
            letter-spacing: 1px;
        }
    }

    // stylelint-disable-next-line
    a.navbar-item:hover, a.navbar-item.is-active, .navbar-link:hover, .navbar-link.is-active {
        color: inherit;
        background-color: transparent;
        // transition-property: all;
        // transition-duration: 750ms;
        // transition-timing-function: ease-out;
    }
    // stylelint-disable-next-line
    .navbar-item.has-dropdown:hover .navbar-link, .navbar-item.has-dropdown.is-active .navbar-link {
        color: inherit;
        background-color: transparent;
    }

    .navbar-dropdown {
        display: flex;
        flex-direction: column;
        color: white;
        text-align: left;
        background-color: $dark-black;
        .navbar-item.router-link-active {
            text-decoration: underline;
            border-bottom: 0;
        }
        a.navbar-item:hover {
            color: inherit;
            background-color: transparent !important;
        }
    }
}

.navbar.main-navigation {
    z-index: 11999; // dropdowns should be visible, but tooltips (like register info) should overlap
    color: white;
    background-color: $dark-black;

    /*
     * slide-out / burger menu
     */
    @media screen and (max-width: $breakpoint-desktop - 1) {
        flex-wrap: wrap;
        .navbar-brand {
            width: calc(100vw - 90px);
        }
        .navbar-burger {
            // ensure navbar-burger visibility (bulma would hide it in between 1024 - 1088px width)
            display: flex;
        }
        .register-button-wrapper, .login-button-wrapper {
            margin-top: 6px !important;
        }
        .navbar-menu {
            $transition-duration: 0.5s;
            display: table;
            flex-direction: column;
            padding: 0;
            text-align: left;
            box-shadow: none;

            .navbar-link {
                display: flex;
            }

            .navbar-start {
                display: block;
                margin: 0 auto 0 0;
                // move this overlay out of view,
                // otherwise it will prevent interacting with the page underneath
                transform: translateX(-1000px);
                transition-duration: 0s;
                transition-delay: 2s; // exit effects transit during this time
                // transition-delay: 0s; // TODO: this needs some tinkering
            }

            .navbar-start > * {
                // slide nav-items to the left
                transform: translateX(-1000px);
                transition-property: all;
                transition-duration: 500ms;
                transition-timing-function: ease-in;
            }

            .navbar-item {
                display: table;
                height: auto;
                line-height: inherit;
                .control.navbar-icon {
                    margin-right: 2.5rem;
                }
                &.index-search {
                    margin-bottom: 1.5rem;
                }
            }

            //- some dropdown items are hidden with bulma .is-hidden-touch class,
            //- but they contained items need "reset" padding and font-size
            .navbar-dropdown {
                display: inline-flex;
                flex-wrap: wrap;
                padding: 0 0 1px;
                font-size: inherit;
                color: inherit;
                background-color: transparent;
                border: 0;
                box-shadow: none !important;
                .navbar-item {
                    display: inline-block;
                    padding-left: 0.75rem;
                }
            }

            .navbar-end {
                .field.is-grouped {
                    flex-direction: row;
                    flex-wrap: wrap;
                    .navbar-item.login {
                        margin-left: 0;
                    }
                }
            }

            .login-button-wrapper.navbar-item,
            .register-button-wrapper.navbar-item {
                // login button is visible outside the burger menu, hide it here
                display: none;
                margin-left: 0;
            }
            .logged-in img {
                margin-right: 1rem;
            }

            .language-select {
                margin: 3px auto auto 0.75rem;
                transform: none; // no scaling
                .navbar-dropdown {
                    flex-direction: row;
                    margin-left: 0.75rem;
                }
                .navbar-link {
                    display: none;
                }
            }

            .user-tool {
                //- hide tools in burger menu mode
                display: none !important;
            }

            // when the burger menu is open on mobile
            &.is-active {
                padding-top: 0.5rem;
                background: rgba(0, 0, 0, 0.95);
                .navbar-start {
                    line-height: inherit;
                    transform: translateX(0);
                    transition-duration: 0s;
                    transition-delay: 0s;
                }
                .navbar-start > * {
                    transform: translateX(0) translateY(0);
                    transition-timing-function: ease-out;
                }
            }
        }

        $items: 12;
        $transition-delay: 0.05s;

        /* stylelint-disable no-duplicate-selectors, no-descending-specificity */

        // Setting delays for the nav items in open transition
        .navbar-menu.is-active {
            .navbar-start {
                @for $i from 1 through $items {
                    & > *:nth-child(#{$i}) {
                        $delay: ($i - 1) * $transition-delay;
                        transition-delay: $delay;
                        // &::after {
                        //     content: "#{$i}"; // debug
                        // }
                    }
                }
            }
        }

        // Setting delays for the nav items in close transition
        .navbar-start {
            @for $i from 1 through $items {
                & > *:nth-child(#{$i}) {
                    $delay: ($items - $i) * $transition-delay;
                    transition-delay: $delay;
                }
            }
        }

        /* stylelint-enable no-duplicate-selectors, no-descending-specificity */
    } // end @media

    .navbar-menu.no-transition > * {
        transition-property: none;
        transition-delay: 0s;
    }

    // important to set default menu height
    @media screen and (min-width: $breakpoint-desktop) {
        .navbar-menu {
            height: auto !important;
        }
    }

    // tiny screen adjustments
    @media screen and (max-width: $breakpoint-mobile - 1) {
        padding-right: 16px;
        padding-left: 16px;
        .navbar-brand {
            width: 95vw;
        }
        .navbar-burger {
            right: 1.5em;
        }
        .navbar-menu.is-active {
            margin-right: 0.5em;
        }
    }

    .login, .register {
        margin: auto 0;
        margin-left: auto;
        &.logged-in {
            z-index: 5000;
            display: flex;
            flex-direction: column;
            padding: 0 0.75rem;
            line-height: normal;
            vertical-align: middle;
            cursor: pointer;
            border: 0px solid white;
            border-radius: 0;
            .material-design-icon {
                margin-right: 0.5rem;
                vertical-align: middle;
            }
            svg {
                color: inherit;
            }
            img.avatar {
                width: auto;
                height: auto;
                max-width: 2rem;
                max-height: 2rem;
                border-radius: 1.25rem;
                object-fit: cover; // NOTE: profile image may be any aspect ratio!
            }
            .navbar-link {
                padding-left: 0;
            }
        }
        // login-button, register-button styles in app.scss
        button {
            // transition to dark background
            @include transition-bezier(all);
            // text-transform: uppercase;
        }
    }
    button.logout {
        cursor: pointer;
        border: 0 !important;
    }
    .language-select {
        display: inline-flex;
        padding-right: 0;
        font-family: $helvetica-bold;
        font-size: inherit;
        line-height: inherit;
        color: inherit;
        text-transform: uppercase;
        cursor: pointer;
        button {
            cursor: pointer;
            border: 0 !important;
        }
    }
    .user-tool {
        display: flex;
        padding: 0.375rem 0 !important;
        .tool-head {
            border-bottom: 0;
            img {
                max-width: unset;
                max-height: 20px;
                margin-left: 1rem;
            }
            h3 {
                font-size: 12px;
            }
        }
        .tool-body {
            width: 100%;
            border-bottom: 2px solid $dark-gray-3;
            a {
                padding: 2px 1rem 0;
                font-family: $helvetica-medium;
                font-size: inherit;
                color: white;
            }
            .material-design-icon {
                width: 18px !important;
                height: 18px !important;
            }
        }
    }
    .invite {
        width: 100%;
    }

    // hide navbar items with 'no-items' classname
    &.no-items {
        .navbar-start > .navbar-item {
            display: none;
        }
    }

    &.no-login {
        .login {
            display: none;
        }
    }

    &.no-register {
        .register {
            display: none;
        }
    }

    &.no-logo {
        .navbar-brand {
            display: none;
        }
    }

    &.fixed {
        position: fixed;
    }
    &.absolute {
        position: absolute;
    }

    &.transparent {
        background: transparent;
        background-color: transparent !important;
        transition: background-color 800ms cubic-bezier(0.08, 0.38, 0.03, 0.63) !important;
        .navbar-link::after {
            transition: border-color 800ms cubic-bezier(0.08, 0.38, 0.03, 0.63) !important;
        }
        .login {
            svg {
                color: inherit !important;
            }
        }
        /* stylelint-disable no-descending-specificity */
        &.light {
            .navbar-item {
                color: $dark-black;
                &:hover {
                    color: $dark-gray-2 !important;
                }
            }
            .navbar-brand, .navbar-burger {
                color: $dark-black !important;
            }
            .navbar-link::after {
                border-color: $dark-black !important;
            }
            .login {
                svg {
                    color: $dark-black !important;
                }
            }
            .language-select {
                color: $dark-black !important;
                &:hover {
                    color: $dark-black !important;
                }
            }
        }
        &.dark {
            .navbar-item {
                color: white;
                &:hover {
                    color: $light-gray !important;
                }
            }
            .navbar-brand, .navbar-burger {
                color: white !important;
            }
            .navbar-link::after {
                border-color: white !important;
            }
            .login > button, .register-button {
                text-shadow: 1px 1px $dark-gray-3;
                border: 0;
                svg {
                    color: white !important;
                }
            }
            .language-select {
                color: white !important;
                text-shadow: 1px 1px $dark-gray-3;
                &:hover {
                    color: white !important;
                }
            }
        }
        .navbar-dropdown .navbar-item {
            color: white !important;
            &:hover {
                color: unset !important;
            }
        }
        /* stylelint-enable no-descending-specificity */
    }
}
</style>
